// src/data/serviceData.js
import typingPrintingImage from '../assets/services/print.jpg';
import onlineApplication from '../assets/services/apply.jpg';
import BusinessCard from '../assets/services/card.png';
import graphicsDesigns from '../assets/services/graphic.webp';
import internetAccesses from '../assets/services/Internet.jpg';
import companyRegistrations from '../assets/services/registration.jpg';
import webService from '../assets/services/web.jpg';
import digitalMarketings from '../assets/services/marketing.webp';
import flyers from '../assets/services/flyer.webp';
import logo from '../assets/services/logo.jpg';
import profile from '../assets/services/profile.webp';
import itSupport from '../assets/services/computer-science.jpg';


const serviceDetails = {
   itSupport: {
  title: "IT Support Services",
  description: "Professional computer repair, software installation, and system optimization services.",
  image: itSupport,
  items: [
    "Hardware Fix (Display Cable) * R400",
    "Labour / Diagnostics * R1000",
    "Speed Optimization * R200",
    "Windows 10/11 Installation * R200",
    "Microsoft Office 365 Installation (Word, Excel, PowerPoint, Outlook, Teams and more) * R300",
    "Microsoft Account Setup * R150",
    "Virus Removal * From R350"
  ]
},
    typingPrinting: {
      title: "Typing & Printing",
      description: "Professional typing and high-quality printing services for all your document needs, from resumes to gloss prints.",
      image: typingPrintingImage,
      items: [
        "Copy B/W * R2",
        "Copy Color * R10",
        "Print Out B/W * R3",
        "Print Out Color * R10",
        "Scan & Email * R5",
        "Online Application * R35",
        "Basic Resume * R15",
        "Modern Resume * R30",
        "Print on Light Gloss * R15",
        "Print on Heavy Gloss * R20",
        "A4 Picture Printing * R10",
        "A6 Picture Printing * R30",
        "ID Photos * R20"
      ]
    },
  
    onlineApplications: {
      title: "Online Applications",
      description: "Fast and accurate online application services for academic, job, and government platforms.",
      image: onlineApplication,
      items: [
        "Academic Applications * R40",
        "Online Job Applications * R40",
        "ID & License Bookings * R40",
        "PSIRA Renewal * R50",
        "SASSA, UIF, SARS Efiling * R50"
      ]
    },
  
    flyers: {
      title: "Flyers",
      description: "Promotional print materials like business flyers to boost your local presence and professionalism.",
      image: flyers,
      items: [
        "A6 Flyer Design",
        "Custom flyer design, 1 side * R150 - R250",
        "Custom flyer design, Double Sided * R250 - R350",
        "  ",
        "A5 Flyer Design",
        "Custom flyer design, 1 side * R200 - R300",
        "Custom flyer design, Double Sided * R350 - R450"
      ]
    },
    BusinessCards: {
        title: "Business Cards",
        description: "Promotional print materials like business cards to boost your local presence and professionalism.",
        image: BusinessCard,
        items: [
          "Business Card Design",
          "Custom design, 1 side * R100 - R150",
          "Custom design, Double Sided * R150 - R250"
        ]
      },
  
    graphicsDesign: {
      title: "Graphics Design",
      description: "Creative graphic design solutions including logos, flyers, menus, and branding materials for businesses.",
      image: graphicsDesigns,
      items: [
        "Flyer, Menu, Sign Design * R250",
        "Business Card Design * R100",
        "Business Profile * R450",
        "Logo Design * R350",
        "Obituary Program Design * R200"
      ]
    },

    profiles: {
        title: "Company Profiles",
        description: "Design impactful company profiles that reflect your values and goals.",
        image: profile,
        items: [
          "Business Profile * R450",
          "Flyer, Menu, Sign Design * R250",
          "Business Card Design * R100",
          "Logo Design * R350",
          "Obituary Program Design * R200"
        ]
      },

    logos: {
        title: "Logo Design",
        description: "Custom logos that speak your brand identity clearly and creatively.",
        image: logo,
        items: [
          "Logo Design * R350",  
          "Flyer, Menu, Sign Design * R250",
          "Business Card Design * R100",
          "Business Profile * R450",
          "Obituary Program Design * R200"
        ]
      },
  
    internetAccess: {
      title: "Internet Access",
      description: "Reliable and affordable on*site internet access packages available for personal and professional use.",
      image: internetAccesses,
      items: [
        "15 Minutes * R10",
        "30 Minutes * R15",
        "1 Hour * R20",
        "2 Hours * R30",
        "4 Hours * R50"
      ]
    },
  
    companyRegistration: {
      title: "Company Registration",
      description: "Get your business legally registered quickly and affordably, including private companies and NPOs.",
      image: companyRegistrations,
      items: [
        "Private Company Registration * R700",
        "NPO/NPC Registration * R1500",
        "CIPC Annual Returns * R150",
        "SARS Annual Returns * R250",
        "CSD Registration * R250"
      ]
    },
  
    webServices: {
      title: "Web Services",
      description: "We offer professional website design and development packages for all business sizes—from affordable, mobile-friendly starter sites to fully custom web apps with ecommerce and CRM integration. All packages include SEO, contact forms, social media integration, and revisions to deliver high-quality, future-ready solutions.",
      image: webService,
      button: {
        label: "Order Now",
        link: "/packages"
      }
    },
    
    
  
    digitalMarketing: {
      title: "Digital Marketing",
      description: "Boost your business online with tailored social media campaigns and content strategies.",
      image: digitalMarketings,
      items: [
        "Social Sites Weekly: 2 Posts Daily * R300",
        "Social Sites Weekly: 1 Post Daily * R200",
        "Social Sites Monthly: 2 Posts Daily * R800",
        "Social Sites Monthly: 1 Post Daily * R600"
      ]
    }
  };
  
  export default serviceDetails;
  